import { FC, useEffect, useState } from 'react';
import { TableContainer, SearchContainer, SearchValue, ErrorType } from '../';
import OperationCenterErrorCard from '../OperationCenterErrorCard/OperationCenterErrorCard';
import { filterData } from '../../utils/searchListValidation';
import type { TableWithSearchTemplatePropsTypes, UserData } from './types/propsTypes';
import styles from './TableWithSearchTemplate.module.scss';

const TableWithSearchTemplate: FC<TableWithSearchTemplatePropsTypes> = ({
  dataSource,
  onRowClick,
  cb,
  theme,
  getColumns,
  response,
  data,
  defaultSearchOptions = null,
  handleSearch,
  searchByStrip = true,
  handleReset,
  hideAddButton = false,
  children = null,
  getBulkActions,
  ...rest
}: TableWithSearchTemplatePropsTypes): JSX.Element => {
  const [filteredData, setFilteredData] = useState<UserData[]>(dataSource);
  const [noResults, setNoResults] = useState<boolean>(false);

  useEffect(() => {
    setFilteredData(dataSource);
    // setNoResults(filteredData.length === 0);
  }, [dataSource]);

  useEffect(() => {
    if (defaultSearchOptions && dataSource) {
      defaultSearch(defaultSearchOptions);
    } else if (defaultSearchOptions === null && dataSource) {
      // Reset to show all data when defaultSearchOptions is explicitly set to null
      setFilteredData(dataSource);
      setNoResults(false);
    }
  }, [dataSource, defaultSearchOptions])

  const defaultSearch = (filteredResponse: SearchValue) => {
    if (handleSearch) {
      handleSearch(filteredResponse); // Call the provided handleSearch function
      sessionStorage.setItem('FilterOptions', JSON.stringify(filteredResponse))
    } else {
      // If handleSearch is is undefined, a default search is used
      const newFilteredData = filterData(dataSource, filteredResponse);
      setFilteredData(newFilteredData);
      sessionStorage.removeItem('Pagination');
      setNoResults(newFilteredData?.length === 0);
      sessionStorage.setItem('FilterOptions', JSON.stringify(filteredResponse))
    }
  };

  const defaultReset = (filteredResponse: SearchValue) => {
    if (handleReset) {
      handleReset(filteredResponse); // Call the provided onAPIReset function
      sessionStorage.removeItem('FilterOptions')
      sessionStorage.removeItem('Pagination');
    } else {
      // If handleSearch is undefined, a default reset is used
      const newFilteredData = filterData(dataSource, filteredResponse);
      setFilteredData(newFilteredData);
      setNoResults(newFilteredData?.length === 0);
      sessionStorage.removeItem('FilterOptions')
      sessionStorage.removeItem('Pagination');
    }
  };
  return (
    <div className={styles['table-with-search-container']}>
      <SearchContainer
        data={data}
        onSearch={defaultSearch}
        searchByStrip={searchByStrip}
        defaultSearchOptions = {defaultSearchOptions}
        onReset={defaultReset}
        response={response}
        hideAddButton={hideAddButton}
      />
      {noResults ? (
        <div className={styles['no-results-container']}>
          <OperationCenterErrorCard errorType={ErrorType.NO_RESULT} />
        </div>
      ) : (
        <>
          {children}
          <TableContainer
            dataSource={filteredData}
            getColumns={getColumns}
            theme={theme}
            onRowClick={onRowClick}
            cb={cb}
            getBulkActions={getBulkActions}
            {...rest}
          />
        </>
      )}
    </div>
  );
};

export default TableWithSearchTemplate;
export type { TableWithSearchTemplatePropsTypes };
